// Strive Custom Animations using GSAP
class StriveAnimations {
  constructor() {
    this.init();
  }

  init() {
    // Register GSAP plugins
    if (typeof gsap !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      this.initScrollAnimations();
    }
  }

  // Fade in from bottom
  fadeInUp(element, delay = 0) {
    gsap.from(element, {
      y: 50,
      opacity: 0,
      duration: 0.8,
      delay: delay,
      ease: 'power3.out'
    });
  }

  // Fade in from left
  fadeInLeft(element, delay = 0) {
    gsap.from(element, {
      x: -50,
      opacity: 0,
      duration: 0.8,
      delay: delay,
      ease: 'power3.out'
    });
  }

  // Fade in from right
  fadeInRight(element, delay = 0) {
    gsap.from(element, {
      x: 50,
      opacity: 0,
      duration: 0.8,
      delay: delay,
      ease: 'power3.out'
    });
  }

  // Scale in animation
  scaleIn(element, delay = 0) {
    gsap.from(element, {
      scale: 0.8,
      opacity: 0,
      duration: 0.6,
      delay: delay,
      ease: 'back.out(1.7)'
    });
  }

  // Scroll triggered animations
  initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    
    animatedElements.forEach((element) => {
      const animationType = element.getAttribute('data-animate');
      const delay = parseFloat(element.getAttribute('data-delay')) || 0;
      
      ScrollTrigger.create({
        trigger: element,
        start: 'top 85%',
        onEnter: () => {
          switch(animationType) {
            case 'fade-up':
              this.fadeInUp(element, delay);
              break;
            case 'fade-left':
              this.fadeInLeft(element, delay);
              break;
            case 'fade-right':
              this.fadeInRight(element, delay);
              break;
            case 'scale':
              this.scaleIn(element, delay);
              break;
          }
        },
        once: true
      });
    });
  }

  // Promo bar ticker animation
  initPromoBarTicker(element) {
    const content = element.querySelector('.promo-bar__content');
    if (!content) return;

    gsap.to(content, {
      x: '-50%',
      duration: 20,
      ease: 'none',
      repeat: -1
    });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.striveAnimations = new StriveAnimations();
  });
} else {
  window.striveAnimations = new StriveAnimations();
}